export const COLUMN_WIDTHS = {
  productInfo: '350px',
  qty: '200px',
  unitPrice: '200px',
  gp: '320px',
  totalPrice: '120px',
  action: '48px'
} as const;
